import React, { Component } from 'react';
import { FormFeedback, FormGroup, Input } from 'reactstrap';
import { Translate, withLocalize } from 'react-localize-redux';


import PropTypes from 'prop-types';


class Title extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      clicked: false,
    };
  }

  handleClick() {
    this.setState({
      clicked: true,
    });
  }

  render() {
    const placeholder = this.props.activeLanguage.code === 'gb'
      ? 'Write a snappy title' : 'Écrivez un titre accrocheur!';
    return (
      <FormGroup>
        <p className="title">
          {' '}
          <Translate id="title.title" />
          {' '}
          *
          {' '}
        </p>

        <Input
          id="title"
          type="text"
          valid={this.props.validate}
          invalid={(!this.props.validate && this.state.clicked)
            || (this.props.isSubmitted && !this.props.validate)}
          placeholder={placeholder}
          value={this.props.title}
          onChange={this.props.handleChange}
          onClick={this.handleClick}
        />


        <FormFeedback invalid={!this.props.validate && this.state.clicked}>
          <Translate id="title.titleFeedback" />
        </FormFeedback>

        {(this.props.isSubmitted && !this.props.validate)
          && <p><Translate id="required" /></p>}
      </FormGroup>
    );
  }
}

Title.propTypes = {
  handleChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  validate: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
};

export default withLocalize(Title);
